package com.shadowings.gero.data.lessons.chapter13

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.shadowings.gero.data.repository.DatabaseRepositoryImpl
import com.shadowings.gero.data.repository.SentenceOptions
import com.shadowings.gero.domain.model.Characters
import com.shadowings.gero.domain.model.ExplanationContent
import com.shadowings.gero.domain.model.Faces
import com.shadowings.gero.domain.model.IExplanation
import com.shadowings.gero.domain.model.IQuizContent
import com.shadowings.gero.domain.model.Option
import com.shadowings.gero.domain.model.SingleSelectionContent
import com.shadowings.gero.presentation.component.MdCWord
import com.shadowings.gero.presentation.model.Verb
import com.shadowings.gero.presentation.model.Word
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.exp_content_preposizione_m_locativa_1
import gero.composeapp.generated.resources.exp_content_preposizione_m_locativa_10
import gero.composeapp.generated.resources.exp_content_preposizione_m_locativa_11
import gero.composeapp.generated.resources.exp_content_preposizione_m_locativa_12
import gero.composeapp.generated.resources.exp_content_preposizione_m_locativa_13
import gero.composeapp.generated.resources.exp_content_preposizione_m_locativa_14
import gero.composeapp.generated.resources.exp_content_preposizione_m_locativa_15
import gero.composeapp.generated.resources.exp_content_preposizione_m_locativa_2
import gero.composeapp.generated.resources.exp_content_preposizione_m_locativa_3
import gero.composeapp.generated.resources.exp_content_preposizione_m_locativa_4
import gero.composeapp.generated.resources.exp_content_preposizione_m_locativa_5
import gero.composeapp.generated.resources.exp_content_preposizione_m_locativa_6
import gero.composeapp.generated.resources.exp_content_preposizione_m_locativa_7
import gero.composeapp.generated.resources.exp_content_preposizione_m_locativa_8
import gero.composeapp.generated.resources.exp_content_preposizione_m_locativa_9
import gero.composeapp.generated.resources.exp_title_preposizione_m_locativa
import gero.composeapp.generated.resources.quiz_preposizione_m_locativa_1
import gero.composeapp.generated.resources.quiz_preposizione_m_locativa_1_opt1
import gero.composeapp.generated.resources.quiz_preposizione_m_locativa_1_opt2
import gero.composeapp.generated.resources.quiz_preposizione_m_locativa_1_opt3
import gero.composeapp.generated.resources.quiz_preposizione_m_locativa_1_opt4
import gero.composeapp.generated.resources.quiz_preposizione_m_locativa_2
import gero.composeapp.generated.resources.quiz_preposizione_m_locativa_2_opt1
import gero.composeapp.generated.resources.quiz_preposizione_m_locativa_2_opt2
import gero.composeapp.generated.resources.quiz_preposizione_m_locativa_2_opt3
import gero.composeapp.generated.resources.quiz_preposizione_m_locativa_2_opt4
import kotlin.random.Random

fun getPreposizioneMLocativaContent(): List<IExplanation> {
    return listOf(
        ExplanationContent(
            title = Res.string.exp_title_preposizione_m_locativa,
            content = Res.string.exp_content_preposizione_m_locativa_1,
            face = Faces.Doubt,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_preposizione_m_locativa,
            content = Res.string.exp_content_preposizione_m_locativa_2,
            face = Faces.Surprised,
            character = Characters.Zeta,
            composable = {
                Box(
                    modifier = Modifier.fillMaxWidth(),
                    contentAlignment = Alignment.Center
                ) {
                    MdCWord(
                        word = "G17",
                        rtl = false,
                        cart = false,
                        size = 72.dp
                    )
                }
            }
        ),
        ExplanationContent(
            title = Res.string.exp_title_preposizione_m_locativa,
            content = Res.string.exp_content_preposizione_m_locativa_3,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_preposizione_m_locativa,
            content = Res.string.exp_content_preposizione_m_locativa_4,
            face = Faces.Doubt,
            character = Characters.Nilo,
        ),
        ExplanationContent(
            title = Res.string.exp_title_preposizione_m_locativa,
            content = Res.string.exp_content_preposizione_m_locativa_5,
            face = Faces.Serious,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_preposizione_m_locativa,
            content = Res.string.exp_content_preposizione_m_locativa_6,
            face = Faces.Idle,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_preposizione_m_locativa,
            content = Res.string.exp_content_preposizione_m_locativa_7,
            face = Faces.Happy,
            character = Characters.Zeta,
        ),
        ExplanationContent(
            title = Res.string.exp_title_preposizione_m_locativa,
            content = Res.string.exp_content_preposizione_m_locativa_8,
            face = Faces.Doubt,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_preposizione_m_locativa,
            content = Res.string.exp_content_preposizione_m_locativa_9,
            face = Faces.Serious,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_preposizione_m_locativa,
            content = Res.string.exp_content_preposizione_m_locativa_10,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_preposizione_m_locativa,
            content = Res.string.exp_content_preposizione_m_locativa_11,
            face = Faces.Idle,
            character = Characters.Zeta,
        ),
        ExplanationContent(
            title = Res.string.exp_title_preposizione_m_locativa,
            content = Res.string.exp_content_preposizione_m_locativa_12,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_preposizione_m_locativa,
            content = Res.string.exp_content_preposizione_m_locativa_13,
            face = Faces.Serious,
            character = Characters.Nilo,
        ),
        ExplanationContent(
            title = Res.string.exp_title_preposizione_m_locativa,
            content = Res.string.exp_content_preposizione_m_locativa_14,
            face = Faces.Happy,
            character = Characters.Alyn,
            composable = {
                Box(
                    modifier = Modifier.fillMaxWidth(),
                    contentAlignment = Alignment.Center
                ) {
                    MdCWord(
                        word = "M17:G17",
                        rtl = false,
                        cart = false,
                        size = 64.dp
                    )
                }
            }
        ),
        ExplanationContent(
            title = Res.string.exp_title_preposizione_m_locativa,
            content = Res.string.exp_content_preposizione_m_locativa_15,
            face = Faces.Happy,
            character = Characters.Zeta,
        ),
    )
}

fun getPreposizioneMLocativaQuizContent(
    verbs: List<Verb>,
    words: List<Word>,
    languageCode: String,
    random: Random = Random,
    verbSentences: List<SentenceOptions> = DatabaseRepositoryImpl.verbSentences
): List<IQuizContent> {
    val specificQuizzes: List<IQuizContent> = listOf(
        SingleSelectionContent(
            text = Res.string.quiz_preposizione_m_locativa_1,
            detail = "",
            options = listOf(
                Option(Res.string.quiz_preposizione_m_locativa_1_opt1, correct = true),
                Option(Res.string.quiz_preposizione_m_locativa_1_opt2, correct = false),
                Option(Res.string.quiz_preposizione_m_locativa_1_opt3, correct = false),
                Option(Res.string.quiz_preposizione_m_locativa_1_opt4, correct = false)
            ).shuffled(random)
        ),
        SingleSelectionContent(
            text = Res.string.quiz_preposizione_m_locativa_2,
            detail = "",
            options = listOf(
                Option(Res.string.quiz_preposizione_m_locativa_2_opt1, correct = true),
                Option(Res.string.quiz_preposizione_m_locativa_2_opt2, correct = false),
                Option(Res.string.quiz_preposizione_m_locativa_2_opt3, correct = false),
                Option(Res.string.quiz_preposizione_m_locativa_2_opt4, correct = false)
            ).shuffled(random)
        )
    )

    // 8 mixed review questions across the three complement shapes seen so far:
    // ḥr-place and ḥr-distribution (lesson 2) plus this lesson's m-locative.
    // Distribution rows are rare in sentences_verbial.tsv (only OFFRIRE/DARE
    // carry one) so it gets a smaller share; if it has no candidate at all its
    // share is redistributed evenly between the other two, same fallback idea
    // as getPreposizioneHrQuizContent.
    val distributionSentences =
        if (hasHrComplementCandidate(HrComplementType.DISTRIBUTION, verbs, verbSentences)) {
            buildHrComplementWordSelectionQuizzes(
                type = HrComplementType.DISTRIBUTION,
                count = 2,
                random = random,
                languageCode = languageCode,
                verbSentences = verbSentences,
                words = words,
                verbs = verbs
            )
        } else {
            emptyList()
        }
    val remainingAfterDistribution = 8 - distributionSentences.size
    val mCount = remainingAfterDistribution / 2
    val placeCount = remainingAfterDistribution - mCount

    val placeSentences = buildHrComplementWordSelectionQuizzes(
        type = HrComplementType.PLACE,
        count = placeCount,
        random = random,
        languageCode = languageCode,
        verbSentences = verbSentences,
        words = words,
        verbs = verbs
    )
    val mSentences = buildMLocativeWordSelectionQuizzes(
        count = mCount,
        random = random,
        languageCode = languageCode,
        verbSentences = verbSentences,
        words = words,
        verbs = verbs
    )

    return specificQuizzes + (placeSentences + distributionSentences + mSentences).shuffled(random)
}
